import { render, staticRenderFns } from "./NewsSectionEditList.vue?vue&type=template&id=da93faec&scoped=true&"
import script from "./NewsSectionEditList.vue?vue&type=script&lang=js&"
export * from "./NewsSectionEditList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da93faec",
  null
  
)

export default component.exports